import { CookiePolicyConfig } from 'common/models/cookie-policy-config'
import AlertBase from 'cookie-banner/base/AlertBase'
import { t } from 'cookie-banner/i18n'
import { loadCosmosAlert } from 'cookie-banner/styles'

export class HotmartHomeAlert extends AlertBase {
  override async loadCompanyStyle(): Promise<void> {
    await loadCosmosAlert()
    await require('./style.css')
  }

  override render(cookiePolicyConfig: CookiePolicyConfig): void {
    const { enableConfigure } = cookiePolicyConfig
    const confirmButtonText = enableConfigure ? t('alert_accept_btn') : t('alert_ok_btn')

    this.root.innerHTML = `
      <div class='cookie-alert-container'>
        <div>
          <div class='cookie-alert-container-header'>
            <p class="cookie-alert-container-header">
              ${t('alert_title')}
            </p>
          </div>
          <div class='cookie-alert-container-body-text'>
            <p>
            ${enableConfigure ? `${t('alert_text')}` : ''}
              ${t('alert_more_information', { ...this.bannerLinks() })}
              ${enableConfigure ? '' : `${t('alert_accept_all_description', { confirmButtonText })}`}
            </p>
          </div>
          <div class='cookie-policy-footer'>
            <button ${
              enableConfigure ? '' : 'hidden'
            } class='cookie-policy-button cookie-policy-go-to-configuration hot-button hot-button--primary'>${t(
      'alert_open_configuration_btn'
    )}</button>
            ${
              enableConfigure
                ? `
                  <button class="cookie-policy-button cookie-policy-accept-only-necessary hot-button hot-button--primary">${t(
                    'alert_accept_only_necessary_btn'
                  )}</button>
                  <button class="cookie-policy-button cookie-policy-accept-all hot-button hot-button--primary">${t(
                    'alert_accept_btn'
                  )}</button>
                `
                : `<button class="cookie-policy-button cookie-policy-accept-all hot-button hot-button--primary">${t(
                    'alert_ok_btn'
                  )}</button>`
            }
          </div>
        </div>
      </div>
    `
  }
}
